// extracted by mini-css-extract-plugin
export default {"marker":"customMarker_marker__QClg5","markerDetails":"customMarker_markerDetails__g1G3y"};